// import * as React from 'react'
import styled from 'styled-components'
import { COMMON, CommonProps } from 'global'
import { flexbox, FlexboxProps } from 'styled-system'

export interface LinkProps extends CommonProps, FlexboxProps {}

export const Link = styled.a<LinkProps>`
  color: inherit;
  ${COMMON}
  ${flexbox}
`
